module.exports = __webpack_public_path__ + "images/tour/lesson_plan_by_day_move_lesson-00dd762a65e161cbe855ac3054e11d32.gif";